<h2 mat-dialog-title>{{ 'unsavedChangesTitle' | i18nextCap }}</h2>
<mat-dialog-content>
  <p>{{ 'REQUEST_PART_DIALOG_MESSAGE' | i18nextCap }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="warn" type="button" mat-dialog-close="cancel">
    {{ 'cancel' | i18nextCap }}
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    (click)="onSaveAndContinue()"
  >
    {{ 'saveAndContinue' | i18nextCap }}
  </button>
</mat-dialog-actions>
